import { render, staticRenderFns } from "./TypeOfWorkField.vue?vue&type=template&id=0237abae"
import script from "./TypeOfWorkField.vue?vue&type=script&lang=js"
export * from "./TypeOfWorkField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports